(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weralis-pdp-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.querySelector('.weralis-pdp .explain');
    if (!wrap) return;
    var tabs = wrap.querySelectorAll('.tabs button');
    var ink = wrap.querySelector('.tabs .ink');
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', String(x === t)); });
        wrap.querySelectorAll('.pane').forEach(function (p) {
          p.classList.toggle('on', p.dataset.p === t.dataset.p);
        });
        if (ink) ink.style.transform = 'translateX(' + i * 100 + '%)';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weralis-pdp-hero"]) return;
  try {
    
  (function () {
    var stage = document.querySelector('.weralis-pdp .pdpstage');
    if (!stage) return;
    var shots = stage.querySelectorAll('.pdpshot');
    var thumbs = document.querySelectorAll('.weralis-pdp .thumbs button');

    function show(index) {
      shots.forEach(function (s) { s.classList.toggle('on', s.dataset.shot === String(index)); });
      thumbs.forEach(function (t) { t.setAttribute('aria-selected', String(t.dataset.go === String(index))); });
      var glow = stage.querySelector('.stageglow');
      if (glow) glow.style.opacity = index === 0 ? '' : '0';
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(Number(t.dataset.go)); });
    });

    /* Свотч переключает всю галерею на кадр своего варианта, а не только
       первый кадр: один общий кадр на все цвета читается как чужой товар. */
    document.querySelectorAll('.weralis-pdp .swatches button').forEach(function (b) {
      b.addEventListener('click', function () {
        document.querySelectorAll('.weralis-pdp .swatches button').forEach(function (x) {
          x.setAttribute('aria-pressed', String(x === b));
        });
        var name = document.querySelector('.weralis-pdp [data-varname]');
        if (name) name.textContent = b.dataset.swatch;
        var target = b.dataset.media;
        if (!target) return;
        shots.forEach(function (s) {
          if (s.dataset.media === target) show(Number(s.dataset.shot));
        });
      });
    });

    document.querySelectorAll('.weralis-pdp [data-scroll]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.dataset.scroll;
        var map = { notify: '.nform', wall: '.pdpwall', scents: '.scents' };
        var target = document.querySelector('.weralis-pdp ' + (map[key] || '.scents'));
        if (!target) return;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weralis-pdpv5-hero"]) return;
  try {
    
  (function () {
    var stage = document.querySelector('.weralis-pdp .pdpstage');
    if (!stage) return;
    var shots = stage.querySelectorAll('.pdpshot');
    var thumbs = document.querySelectorAll('.weralis-pdp .thumbs button');
    function show(index) {
      shots.forEach(function (s) { s.classList.toggle('on', s.dataset.shot === String(index)); });
      thumbs.forEach(function (t) { t.setAttribute('aria-selected', String(t.dataset.go === String(index))); });
      var glow = stage.querySelector('.stageglow');
      if (glow) glow.style.opacity = index === 0 ? '' : '0';
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(Number(t.dataset.go)); });
    });
    var vbtn = document.querySelectorAll('.weralis-pdp .v5var button');
    vbtn.forEach(function (b) {
      b.addEventListener('click', function () {
        vbtn.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        var n = document.querySelector('.weralis-pdp [data-varname]'); if (n) n.textContent = b.dataset.v;
        document.querySelectorAll('.weralis-pdp .buy .price, .weralis-pdp .stitle span').forEach(function (el, i) {
          el.textContent = i === 0 ? b.dataset.price : b.dataset.price + ' · not for sale yet';
        });
        /* 03.10, п.22: кадр выбранного варианта первым, кадры чужого цвета скрыты */
        if (!b.dataset.img) return;
        var s0 = stage.querySelector('.pdpshot[data-shot="0"] img');
        var t0 = document.querySelector('.weralis-pdp .thumbs button[data-go="0"] img');
        if (s0) { s0.src = b.dataset.img; s0.alt = b.dataset.alt || ''; }
        if (t0) t0.src = b.dataset.thumb;
        var mids = [], others = [];
        vbtn.forEach(function (x) {
          if (x.dataset.mid) mids.push(x.dataset.mid);
          if (x !== b) others.push((x.dataset.v || '').toLowerCase());
        });
        thumbs.forEach(function (t) {
          if (!t.dataset.mid) return;
          t.hidden = mids.indexOf(t.dataset.mid) > -1 ||
                     (t.dataset.tone !== '' && others.indexOf(t.dataset.tone) > -1) ||
                     (!!t.dataset.variant && t.dataset.variant !== b.dataset.v);
        });
        show(0);
      });
    });
    /* Заявка без перезагрузки: подтверждение на месте, страница не прыгает (04.10).
       05.10: капча Shopify. Её слушатель ставит h-captcha-response и зовёт form.submit();
       наш preventDefault раньше неё оставлял запрос без токена (400 Missing CAPTCHA token)
       и уводил в перезагрузку. Теперь отправку перехватываем на form.submit(), после капчи;
       если капчи нет — на window, последним. Форму не пересобираем: поля скрываются (display, не hidden — .btn сильнее). */
    /* 06.10: товар заявки — событием в Klaviyo, письмо рисуется из события, а не из тегов Shopify
       (тег доезжал позже подписки, письмо показывало старый товар). Shopify-форма остаётся как была. */
    function toKlaviyo(email) {
      var el = document.getElementById('wr-kl');
      if (!el || !email || !window.fetch) return;
      var k; try { k = JSON.parse(el.textContent); } catch (e) { return; }
      var chip = document.querySelector('.weralis-pdp .v5var button[aria-pressed="true"]');
      var img = (chip && chip.dataset.thumb) || k.image;
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var api = 'https://a.klaviyo.com/client/', q = '/?company_id=' + k.company;
      var h = { 'content-type': 'application/vnd.api+json', 'revision': '2026-07-15' };
      var post = function (path, body) {
        return fetch(api + path + q, { method: 'POST', headers: h, keepalive: true, body: JSON.stringify(body) })
          .catch(function () {});
      };
      post('subscriptions', { data: { type: 'subscription', attributes: {
        custom_source: 'Notify me',
        profile: { data: { type: 'profile', attributes: { email: email,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
        relationships: { list: { data: { type: 'list', id: k.list } } } } });
      post('events', { data: { type: 'event', attributes: {
        metric: { data: { type: 'metric', attributes: { name: 'Joined Waitlist' } } },
        profile: { data: { type: 'profile', attributes: { email: email } } },
        properties: { ProductHandle: k.handle, ProductName: k.name, ProductURL: k.url,
          ImageURL: img, Variant: chip ? chip.dataset.v : '' } } } });
    }
    document.querySelectorAll('.weralis-pdp form.pform').forEach(function (f) {
      if (!window.fetch || !window.FormData) return;
      var nativeSubmit = HTMLFormElement.prototype.submit;
      var consent = f.parentNode.querySelector('.consent');
      var busy = false, retried = false;
      function send() {
        if (busy) return;
        busy = true;
        var data = new FormData(f);
        toKlaviyo(data.get('contact[email]'));
        var kids = Array.prototype.slice.call(f.children);
        f.style.minHeight = f.offsetHeight + 'px';
        kids.forEach(function (k) { k.style.display = 'none'; });
        var msg = document.createElement('p');
        msg.className = 'sent';
        msg.setAttribute('role', 'status');
        msg.innerHTML = '<span class="tick" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24"><path d="M5 12.5l4.2 4.2L19 7"/></svg></span>' +
          '<span><b>You\'re on the list.</b> We\'ll email you when it\'s on sale.</span>';
        f.appendChild(msg);
        f.classList.add('is-sent');
        if (consent) consent.style.visibility = 'hidden';
        fetch(f.action, { method: 'POST', body: data, credentials: 'same-origin' })
          .then(function (r) {
            /* Shopify просит видимую капчу: её страница сама дошлёт заявку (form_key). 05.10 */
            if (/challenge/.test(r.url)) { location.href = r.url; return; }
            if (!r.ok) throw new Error('fallback');
          })
          .catch(function () {
            msg.remove();
            kids.forEach(function (k) { k.style.display = ''; });
            f.classList.remove('is-sent');
            f.style.minHeight = '';
            if (consent) consent.style.visibility = '';
            busy = false;
            /* Токен капчи одноразовый: повтор с ним = «Invalid CAPTCHA token». Один повтор через капчу. */
            if (!f.dataset.hcaptchaBound) nativeSubmit.call(f);
            else if (!retried) { retried = true; f.submit(); }
          });
      }
      f.submit = send;
      window.addEventListener('submit', function (e) {
        if (e.target !== f || e.defaultPrevented) return;
        e.preventDefault();
        send();
      });
    });
    /* После перезагрузки через проверку Shopify: форма по центру, адрес чистый (05.10). */
    if (/customer_posted=true/.test(location.search)) {
      var pf = document.querySelector('.weralis-pdp form.pform');
      if (pf && pf.querySelector('.sent')) {
        history.replaceState(null, '', location.pathname);
        pf.scrollIntoView({ block: 'center' });
      }
    }
    document.querySelectorAll('.weralis-pdp [data-scroll="notify"]').forEach(function (b) {
      b.addEventListener('click', function () {
        var target = document.querySelector('.weralis-pdp .pform');
        if (!target) return;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
